import { render, staticRenderFns } from "./Cobranzas.vue?vue&type=template&id=3bff2c4b&"
import script from "./Cobranzas.vue?vue&type=script&lang=js&"
export * from "./Cobranzas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QTable,QTd,QRating,QSelect} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QTable,QTd,QRating,QSelect})
